import React, { useEffect, useRef, useState } from 'react'
import { API } from './config'
import * as XLSX from 'xlsx';
import Loader from './Loader';
import axios from 'axios';
import Swal from 'sweetalert2';

const MastersEducationOccupation = () => {

    const [details, setDetails] = useState()
    const [showbutton, setShowbutton] = useState()
    const [activeBtn, setActiveBtn] = useState()
    const [showData, setShowData] = useState()


    const [members, setMembers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [searchMembers, setSearchMembers] = useState('')
    const [loading, setLoading] = useState(false)
    const containerRef = useRef(null);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [addBox, setAddBox] = useState(false)
    const [addDetails, setAddDetails] = useState('')
    const [addFlag, setAddFlag] = useState(true)
    const [updateMaster, setUpdateMaster] = useState(null);
    const [updateDetails, setUpdateDetails] = useState({}); // Store all update details
    const [updateFlag, setUpdateFlag] = useState(true);




    const getMasterEducationOccupatipn = async () => {
        setLoading(true)
        try {
            const response = await fetch(`${API}?action=masterlist`, {
                method: 'GET',
                headers: {
                    Accept: '*/*',
                    'content-type': 'application/json'
                },
            })
            const data = await response.json()
            if (!response.ok) {
                throw new Error(data?.messge || "fild to fetch data")
            }
            if (data) {

                const groupedData = data.reduce((acc, item) => {
                    if (!acc[item.list_name]) {
                        acc[item.list_name] = [];
                    }
                    acc[item.list_name].push(item);
                    return acc;
                }, {});
                const uniqueKeys = [...new Set(data.map(item => item.list_name))];
                setDetails(groupedData)
                setShowbutton(uniqueKeys);
                setActiveBtn(uniqueKeys?.[0]);
                setLoading(false)
            }

        } catch (err) {
            setLoading(false)

        }
    }

    useEffect(() => {
        getMasterEducationOccupatipn()
    }, [])


    useEffect(() => {
        if (details && activeBtn) {
            setShowData(details[activeBtn] || []);
        }
    }, [details, activeBtn])


    const filteredMembers = showData?.filter(el => el?.list_label?.toLowerCase().includes(searchMembers.toLowerCase()));

    // Calculate pagination data
    const totalPages = Math.ceil(filteredMembers?.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredMembers?.slice(startIndex, startIndex + itemsPerPage);

    // Pagination Handlers
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    // xl format
    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(paginatedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Members');
        XLSX.writeFile(workbook, 'members.xlsx');
    };


    // drage function 
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - containerRef.current.offsetLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - containerRef.current.offsetLeft;
        const walk = x - startX;
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        setScrollLeft(containerRef.current.scrollLeft);
    };


    const addMaster = () => {
        const payload = {
            active_flag: addFlag,
            list_label: addDetails,
            list_name: activeBtn,
            list_value: addDetails,
            masterlistid: ""
        }
        axios.post(`${API}?action=updatemaster&format=new`, { payload })
            .then((res) => {
                if (res?.data?.status) {
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "success"
                    });
                    setAddBox(false);
                    setAddDetails('');
                    setAddFlag(true)

                }
                else {
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "error"
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }


    const updateMasters = () => {
        if (!updateMaster) return;
        const payload = {
            active_flag: updateFlag,
            list_label: updateDetails.list_value,
            list_value: updateDetails.list_value,
            list_name: activeBtn,
            masterlistid: updateDetails?.masterlistid

        };

        axios.post(`${API}?action=updatemaster&format=new`, { payload })
            .then((res) => {
                if (res?.data?.status) {
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "success"
                    });
                    setUpdateMaster(null);
                }
                else {
                    Swal.fire({
                        title: "",
                        text: (res?.data?.msg),
                        icon: "error"
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }







    return (
        <>
            {
                loading &&
                <Loader />
            }
            <div class=' mt-3 m-auto ' style={{ width: '95%' }}>
                {addBox &&
                    <div class='d-flex align-items-center justify-content-center' style={{ width: '100%', height: '100%', position: 'fixed', background: 'rgba(0,0,0,0.7)', zIndex: '10' }}>
                        <div class='col-lg-5 col-md-7 col-11 m-auto bg-white'>
                            <div class='col-11 my-2 m-auto'>
                                <p class='fw-bold fs-3'>Add {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)}</p>
                                <div class='text-start'>
                                    <label htmlFor="add">Enter {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)}</label>
                                    <input type="text" id='add' class='form-control' onChange={(e) => setAddDetails(e?.target?.value)} placeholder={`add ${activeBtn}`} />
                                </div>
                                <div class="form-check form-switch  d-flex gap-2 mt-2">
                                    <input class="form-check-input" onClick={() => setAddFlag(!addFlag)} type="checkbox" role="switch" id="actieMaster" checked={addFlag ? true : false} />
                                    <label class="form-check-label" for="actieMaster" >Active</label>
                                </div>
                                <div class='d-flex gap-3 align-items-center mt-3'>
                                    <button class='btn btnBlue' onClick={() => addMaster()}>Add {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)} </button>
                                    <button class='btn btn-danger rounded-5' onClick={() => { setAddBox(false); setAddDetails(''); setAddFlag(true) }}>Cancel</button>
                                </div>

                            </div>
                        </div>
                    </div>
                }

                {updateMaster &&
                    <div class='d-flex align-items-center justify-content-center' style={{ width: '100%', height: '100%', position: 'fixed', background: 'rgba(0,0,0,0.7)', zIndex: '10' }}>
                        <div class='col-lg-5 col-md-7 col-11 m-auto bg-white'>
                            <div class='col-11 my-2 m-auto'>
                                <p class='fw-bold fs-3'>Update {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)}</p>
                                <div class='text-start'>
                                    <label htmlFor="add">Enter {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)}</label>
                                    <input type="text" id='add' class='form-control' value={updateDetails?.list_value} onChange={(e) => setUpdateDetails({ ...updateDetails, list_value: e.target.value })} />
                                </div>
                                <div class="form-check form-switch  d-flex gap-2 mt-2">
                                    <input class="form-check-input" onClick={() => setUpdateFlag(!updateFlag)} type="checkbox" role="switch" id="updateListValue" checked={updateFlag} />
                                    <label class="form-check-label" htmlFor="updateListValue" >Active</label>
                                </div>
                                <div class='d-flex gap-3 align-items-center mt-3'>
                                    <button class='btn btnBlue' onClick={() => updateMasters()}>Update {activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)} </button>
                                    <button class='btn btn-danger rounded-5' onClick={() => setUpdateMaster('')}>Cancel</button>
                                </div>

                            </div>
                        </div>
                    </div>
                }

                {/* <div class=' m-auto d-flex align-items-center   mt-2' style={{ borderBottom: "1px solid gray" }}>
                    <div class=' d-flex align-items-center gap-4   flex-nowrap' style={{ overflowX: 'auto' }}>
                        {
                            showbutton && showbutton?.map((el) => {
                                return (
                                    <div class='p-2 py-1 fs-5' style={activeBtn == el ? { borderBottom: '2px solid #034DA2', cursor: "pointer" } : { cursor: 'pointer' }} onClick={() => setActiveBtn(el)}>
                                        {el?.charAt(0).toUpperCase() + el?.slice(1)}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div> */}

                <div class='d-flex gap-3' style={{ overflowX: 'auto', cursor: 'grab', borderBottom: '1px solid gray' }} ref={containerRef} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp}>
                    {
                        showbutton && showbutton?.map((el) => {
                            return (
                                <div class='p-2 py-1 fs-5' style={activeBtn == el ? { borderBottom: '2px solid #034DA2', cursor: "pointer", fontWeight: 'bold' } : { cursor: 'pointer' }} onClick={() => setActiveBtn(el)}>
                                    {el?.charAt(0).toUpperCase() + el?.slice(1)}
                                </div>
                            )
                        })
                    }
                </div>

                <div>
                    <div className='text-start p-3  mt-3 rounded-4' style={{ background: '#fff' }}>
                        <div class='d-flex align-items-center justify-content-between gap-2 flex-nowrap'>
                            <div class=''>
                                <p className='fs-3 fw-bold'>{activeBtn?.charAt(0).toUpperCase() + activeBtn?.slice(1)}</p>
                            </div>
                            <div className='d-flex align-items-center  gap-2'>
                                <input type="text" className='form-control rounded-5  ' placeholder="Search...." onChange={(e) => setSearchMembers(e?.target?.value)} />
                                <p className='fs-3' style={{ cursor: 'pointer' }} onClick={() => setAddBox(true)}><i className="bi bi-plus-circle"></i></p>
                                <p className='fs-3' style={{ cursor: 'pointer' }} onClick={downloadExcel}><i className="bi bi-arrow-up-right-circle"></i></p>
                            </div>
                        </div>


                        {/* Table */}
                        <div style={{ width: '100%', overflowX: 'auto' }}>
                            <table class='table mt-3 '   >
                                <thead >
                                    <tr>
                                        <th class='text-nowrap '> Name</th>
                                        <th class='text-nowrap '> Action</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedData?.map((details, index) => (
                                        <tr key={index}>
                                            <td>{details.list_label || "-"}</td>
                                            <td> <p onClick={() => {
                                                setUpdateMaster(details);
                                                setUpdateDetails({ ...details }); // Set ALL details for update
                                                setUpdateFlag(details.active_flag === "1" || details.active_flag === true); // Handle different active_flag types
                                            }}><i className="bi bi-pencil-fill"></i></p></td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div class='d-flex align-items-center justify-content-between flex-wrap gap-3'>

                            {/* Pagination Controls */}
                            <div class='d-flex align-items-center gap-3'>
                                <button class='btn btnBlue py-2 ' onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <i class="bi bi-caret-left-fill"></i>
                                </button>
                                <span class=' '>Page {currentPage} of {totalPages}</span>
                                <button class='btn btnBlue py-2 ' onClick={handleNextPage} disabled={currentPage === totalPages}>
                                    <i class="bi bi-caret-right-fill"></i>
                                </button>
                            </div>

                            {/* Items Per Page Selector */}
                            <div class='d-flex align-items-center  gap-3' >
                                <label class=' '>Items per page: </label>
                                <select class="form-select"
                                    value={itemsPerPage}
                                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                    style={{ width: '100px' }}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </>
    )
}

export default MastersEducationOccupation